var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image-interlayer"},[_c('img',{attrs:{"src":_vm.image,"alt":""}}),(_vm.showMore)?_c('div',{staticClass:"more",on:{"click":function($event){return _vm.goto(_vm.url)}}},[_vm._v("更多")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }